// Written around questions Kenyans actually search. Edit to match how you really work.
export const FAQS = [
  {
    q: "How much does borehole drilling cost in Kenya?",
    a: "The price depends on the depth, the ground conditions (hard rock or softer sediments), the casing used, the pump and where your land is. After a site survey we send an itemised quote, so you know the full cost before any drilling starts.",
  },
  {
    q: "Do I need a permit to drill a borehole in Kenya?",
    a: "Yes. Groundwater is regulated by the Water Resources Authority (WRA), which requires a hydrogeological survey and a drilling permit before you drill. We carry out the water survey and can guide you through the process.", // TODO: confirm wording matches what you actually offer
  },
  {
    q: "How long does it take to drill a borehole?",
    a: "Drilling usually takes a few days to a couple of weeks depending on depth and rock type, followed by development and a pump test. We confirm the timeline in your quote.",
  },
  {
    q: "Can solar power run a borehole pump?",
    a: "Yes. A solar water pumping system uses panels to power the pump directly, which removes fuel and grid costs for irrigation, livestock and households. We size the system to your borehole depth, yield and daily water demand.",
  },
  {
    q: "Which areas do you serve?",
    a: "We are based in Thika and serve homes, farms and businesses in Thika, Ruiru, Juja, Kiambu, Nairobi and across Kenya.",
  },
  {
    q: "Do you maintain and repair existing boreholes and solar systems?",
    a: "Yes. We service pumps, replace worn parts and check borehole and solar systems so your water and power keep running.",
  },
];